import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";
import { WishlistSdkDto } from "../types";

class GetWishlistsSdkMethodPayload
    implements SdkMethodPayloadInterface<WishlistSdkDto[]>
{
    public readonly methodName: WISHLISTS_SDK_METHODS.GET_WISHLISTS;

    constructor(
        public readonly onSuccess: (result: WishlistSdkDto[]) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.GET_WISHLISTS;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetWishlistsSdkMethodPayload;
